import gql from "graphql-tag";

export const GET_BEST_TIME_SLICE_VALUES = gql`
  query GET_BEST_TIME_SLICE_VALUES($input: BestTimeSliceValueRequestInput!) {
    bestTimeSliceValues(input: $input) {
      instant
      value
    }
  }
`;
